import { APIClient } from '../infra/APIClient'
import { APIConfig, CursorPaged } from '../types/definitions'
import { FindLegendsQuery, LegendDTO } from './dtos/legend'
import { rethrowRequestError } from '../utils/error-util'

/**
 * Supported Engine Version.
 */
export const SUPPORTED_ENGINE_VERSION = '1.15.1'

/**
 * Legend API
 */
export interface LegendAPI {
  legends: LegendAPIClient
}

/**
 * Legend API
 * @param opts
 */
export function createLegendAPI(opts: APIConfig): LegendAPI {
  return {
    legends: new LegendAPIClient(opts),
  }
}

/**
 * Legend API client.
 */
export class LegendAPIClient extends APIClient {
  /**
   * Finds legends in a workspace.
   *
   * @param workspace_id
   * @param query
   */
  find({
    workspace_id,
    ...query
  }: FindLegendsQuery): Promise<CursorPaged<LegendDTO>> {
    return this.client
      .get(`/v3/workspaces/${workspace_id}/legends`, {
        params: query,
      })
      .then(this._data)
      .catch(rethrowRequestError)
  }

  /**
   * Gets a single legend.
   * @param legendId
   * @param version
   */
  get(
    legendId: string,
    version?: number,
    supportedEngineVersion?: string
  ): Promise<LegendDTO> {
    return this.client
      .get(
        typeof version === 'number'
          ? `/v3/legends/${legendId}/versions/${version}`
          : `/v3/legends/${legendId}`,
        {
          params: {
            supported_engine_version: supportedEngineVersion,
          },
        }
      )
      .then(this._data)
      .catch(rethrowRequestError)
  }
}
